import { useEffect, useState } from "react";
import { default as axios } from "../axiosConfig";
import MetricGroupCard from "./MetricGroupCard";
import Skeleton from "@mui/material/Skeleton";
import GroupIcon from "@mui/icons-material/Group";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import { API_GetInfoTechUserSummary } from "../Assets/ApiUrlContainer";

function MetricCardSkeleton() {
  return (
    <div className="metric-card">
      <Skeleton variant="text" width={120} height={30} />
      <Skeleton variant="text" width={60} height={40} />
    </div>
  );
}

export default function ITLandingPage({ user }) {
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const res = await axios.get(API_GetInfoTechUserSummary);
        setSummary(res.data);
        setError(null);
      } catch (err) {
        console.error("Error fetching IT landing summary:", err);
        setError("Failed to load dashboard data.");
      }
    };

    fetchSummary();
  }, []);

  const isLoading = !summary && !error;

  return (
    <div className="landing-content">
      <div className="metric-panel">
        <div className="welcome-header">
          <h1>Welcome {user.firstname} {user.lastname}</h1>
        </div>

        {error && <div className="error-message">{error}</div>}

        {isLoading ? (
          <div className="metric-group">
            <div className="landing-grid">
              {[...Array(6)].map((_, i) => (
                <MetricCardSkeleton key={i} />
              ))}
            </div>
          </div>
        ) : (
          <div className="grid-two-columns">
            {/* User Group */}
            <MetricGroupCard
              className="group-card group-user"
              title={<><GroupIcon style={{ marginRight: "8px" }} />User Summary</>}
              metrics={[
                {
                  label: "Active Users",
                  value: summary.totals.totalUsers ?? 0
                },
                {
                  label: "Active Consultants",
                  value: summary.totals.activeConsultants ?? 0
                },
                {
                  label: "New Users This Week",
                  value: summary.totals.newUsers ?? 0
                },
                {
                  label: "Locked or Banned",
                  value: summary.totals.lockedOrBanned ?? 0
                }
              ]}
            />

            {/* Jobs Group */}
            <MetricGroupCard
              className="group-card group-jobs"
              title={<><WorkOutlineIcon style={{ marginRight: "8px" }} />Job Summary</>}
              metrics={[
                {
                  label: "Applications This Week",
                  value: summary.jobs.totalApplications ?? 0
                },
                {
                  label: "Total Jobs in System",
                  value: summary.jobs.totalJobs ?? 0
                }
              ]}
            />
          </div>
        )}
      </div>
    </div>
  );
}